import './App.css';
import {Component} from "react";
import QRCode from "react-qr-code";
import logo from "./cena en rojo_horizontal.svg";
import stc from "./logo_stc_horizontal.png";
import {getTicket} from "./helper";

export default class App extends Component {

    componentDidMount() {
        getTicket()
    }

    render() {
        return (
            <div className={"App"}>
                <div className="ticket">
                    <div className="image">
                        <img src={stc} alt=""/>
                        <img src={logo} alt="" loading="lazy" />
                    </div>
                    <div className="info">
                        <div className="row">
                            <div className="item ">
                                <label htmlFor="">Mesa</label>
                                <div className="data mesa">

                                </div>
                            </div>
                            <div className="item">
                                <label htmlFor="">Asientos</label>
                                <div className="data asientos">

                                </div>
                            </div>
                            <div className="item">
                                <label htmlFor="">Ubicación</label>
                                <div className="data">
                                    <a href="https://www.google.com/maps/place/Papalote+Museo+del+Ni%C3%B1o/@19.4117058,-99.1975965,17z/data=!3m1!4b1!4m6!3m5!1s0x85d201e145a66e01:0xef24f33f16b9a87d!8m2!3d19.4117008!4d-99.1950216!16s%2Fm%2F080gds2?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoKLDEwMDc5MjA3MUgBUAM%3D" target="_blank">Ver mapa</a>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="item">
                                <label htmlFor="">Propietario</label>
                                <div className="data comprador">

                                </div>
                            </div>
                            <div className="item">
                                <label htmlFor="">Hora</label>
                                <div className="data">
                                    19:00
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="qr">

                    </div>
                </div>
            </div>
        )
    }
}